import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { EditDataTypeComponent } from "../dialogs/edit-data-type/edit-data-type.component";
import { DataTypeAccessRightsComponent } from "../dialogs/data-type-access-rights/data-type-access-rights.component";
import { DataCatalogueService } from "../services/data-catalogue.service";
import { DataTypeDefinition } from "../model/data-type";

@Component({
  selector: "app-data-type",
  templateUrl: "./data-type.component.html",
  styleUrls: ["./data-type.component.scss"],
})
export class DataTypeComponent implements OnInit {
  dataType: string | null = null;
  displayedColumns: string[] = [
    "allowedValue",
    "lock",
    "actions",
    "description",
  ];
  apiData: DataTypeDefinition | null = null;
  lastEditedBy: string = "-";
  lastEditedOn: string = "-";
  allowedValues: { allowedValue: string; description: string }[] = [];

  constructor(
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private catalogService: DataCatalogueService,
  ) {}

  ngOnInit(): void {
    this.dataType = this.route.snapshot.paramMap.get("dataType");
    const catId = "2037172d-1390-4033-9017-e5424166927e";
    const ns = "aixm";

    console.log("Data type:", this.dataType);

    this.catalogService.getDataType(catId, ns, this.dataType).subscribe({
      next: (data) => {
        this.apiData = data;
        const version = data.versions?.[0];
        this.lastEditedBy = version?.author;
        this.lastEditedOn = version?.timestamp;

        this.allowedValues =
          version?.enumerations?.map((e) => ({
            allowedValue: e.value,
            description:
              e.displayName?.find((d) => d.lang === "en")?.text ||
              e.displayName?.[0]?.text ||
              "",
          })) || [];
      },
      error: (err) => console.error(err),
    });
  }

  // allowedValues = [
  //   {
  //     allowedValue: "ICAO",
  //     description: "ICAO 5 letter name code designator.",
  //   },
  //   { allowedValue: "COORD", description: "Point with identifier..." },
  //   { allowedValue: "CNF", description: "Computer Navigation Fix." },
  //   { allowedValue: "DESIGNED", description: "Bearing/distance designator." },
  //   { allowedValue: "MTR", description: "Military training route point." },
  //   { allowedValue: "TERMINAL", description: "Five-alphanumeric name-code." },
  //   { allowedValue: "BRG_DIST", description: "Bearing/distance code." },
  //   { allowedValue: "OTHER:VRP", description: "VFR reporting point." },
  // ];
  deleteEnum(element: { allowedValue: string }): void {
    const enumValue = element.allowedValue;

    this.catalogService
      .deleteEnumeration(
        "2037172d-1390-4033-9017-e5424166927e",
        "aixm",
        this.dataType!,
        enumValue,
      )
      .subscribe({
        next: () => {
          this.allowedValues = this.allowedValues.filter(
            (v) => v.allowedValue !== enumValue,
          );
        },
        error: (err) => console.error(err),
      });
  }
  openDialog(element?: any): void {
    const dialogRef = this.dialog.open(EditDataTypeComponent, {
      width: "600px",
      data: {
        dataType: this.dataType,
        element: element ? { ...element } : null,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

      const catId = "2037172d-1390-4033-9017-e5424166927e";
      const ns = "aixm";

      const enumValue = result.allowedValue;

      // 👉 NOVI API BODY
      const payload = {
        displayName: [
          {
            lang: "en",
            text: result.description || "",
          },
        ],
        value: result.allowedValue,
      };

      this.catalogService
        .createOrUpdateEnum(catId, ns, this.dataType!, enumValue, payload)
        .subscribe({
          next: () => {
            console.log("Enumeration saved");

            if (element) {
              Object.assign(element, result);
            } else {
              this.allowedValues.push(result);
            }

            // sortiranje
            const nonOther = this.allowedValues.filter(
              (v) => !v.allowedValue.startsWith("OTHER"),
            );

            const other = this.allowedValues
              .filter((v) => v.allowedValue.startsWith("OTHER"))
              .sort((a, b) => a.allowedValue.localeCompare(b.allowedValue));

            this.allowedValues = [...nonOther, ...other];
          },
          error: (err) => {
            console.error("Error saving enumeration:", err);
          },
        });
    });
  }

  openAccess(allowedValue: string): void {
    const dialogRef = this.dialog.open(DataTypeAccessRightsComponent, {
      width: "800px",
      data: { value: allowedValue, dataType: this.dataType },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dijalog zatvoren, rezultat:", result);
    });
  }
}
